import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  /**
   * GET `/series/device/{type}/pulse` — nilai terakhir per device. SUDAH di-unwrap:
   * yang balik array baris, bukan response axios.
   *
   * Tiga nilai balik yang artinya beda:
   * - `Object[]` isi `res.data.data.series`
   * - `[]` gak ada data, ATAU request gagal (dicatat ke console, gak nge-throw)
   * - `null` DITOLAK IZIN — backend balikin HTTP 200 dengan `status.errorCode` 412 di
   *   body, jadi axios gak throw dan harus dicek manual
   *
   * `null` sengaja dibedain dari `[]` biar pemanggil bisa bilang "sensor gak ada/mati"
   * vs "emang gak boleh diliat". Yang butuh array polos normalin sendiri
   * (src/store/asset.js:211), yang butuh daftar sensor yang ditolak ngumpulin key
   * bernilai null (src/store/asset.js:508).
   *
   * @param {string[]} devices devcUniqueId, atau massSateliteId kalau mode 'sat'
   * @param {string} type 'gps' | 'rpm' | 'ae' | 'flowmeter' | 'temperature' | 'powermeter'
   * @param {string} [mode='standard'] 'sat' ngubah path jadi `satellite/{type}` buat
   *   gps, rpm, dan ae doang — tipe lain jalannya tetep lewat path biasa
   * @returns {Promise<Object[]|null>} body sudah di-unwrap
   */
  async getPulse(devices, type, mode = 'standard') {
    try {
      // Use satellite endpoint for sat mode when fetching GPS or RPM data
      const isSatMode = mode === 'sat';
      let processedType = type;

      if (isSatMode) {
        if (type === 'gps') {
          processedType = 'satellite/gps';
        } else if (type === 'rpm') {
          processedType = 'satellite/rpm';
        } else if (type === 'ae') {
          processedType = 'satellite/ae';
        }
      }

      const config = {
        params: { device: devices },
        cancelToken: getNewCancelToken(),
      };
      const response = await axiosInstance.get(`/series/device/${processedType}/pulse`, config);
      if (response?.data?.status?.errorCode === 412) {
        return null;
      }
      return response?.data?.data?.series || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};
